import i18n from '@pages/i18n';
import { getLastSelectedIndex, setLastSelectedIndex } from './solutionMemory';
import solutionContents from '@src/lang/ko/enterprise/solutionContents';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';
import { useLayoutEffect, useRef, useState } from 'react';
import home from '@src/lang/ko/main/home/home';
import React from 'react';
import { ExtraContentCard, ExtraContentLayout, ExtraContentSection } from './ExtraContent.style';
import { StyledDisplay } from '@components/Text';
import { Trans } from 'react-i18next';
import { ImgWH, LabelColor, ParagraphColor, Spacing, SpacingDTM, SpacingR } from '@pages/CommonStyle/common.style';
import { DivFlexColumn, DivFlexRow } from '@pages/CommonStyle/commonDiv.style';
import { BannerProductButton, BannerProductCardViewport } from '@pages/Main/Home/components/Banner/Banner.style';
import { IconArrowLeftWhite, IconArrowRightWhite, IconArrowUpWhite } from '@assets/images/icon';
import { HomeProductCard, HomeProductCardTrack, ImgWHRotation, ShowLabel } from '@pages/Main/Home/components/Solution/Solution.style';
import { HeadingH3white } from '@components/Text/Heading/Heading.style';
import { ShowMoreButton } from '@pages/CommonStyle/commonBtn';
import { StyledGridContainer } from '@components/Grid/Grid.style';
import { extraContentBanner } from '@assets/images/solution';

const ExtraContentSolution = ({ type }) => {
  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);
  // const cards = [0, 1, 2, 3, 4, 5];

  const cards = type === 'blog' ? solutionContents.contents : home.solution;
  const dataPath = type === 'blog' ? 'solutionContents.contents' : 'home.solution';

  const [selectedIndex, setSelectedIndexState] = useState(getLastSelectedIndex());
  const selectedIndexRef = useRef(selectedIndex);

  const setSelectedIndex = (value: number | ((prev: number) => number)) => {
    const newIndex = typeof value === 'function' ? value(selectedIndexRef.current) : value;
    selectedIndexRef.current = newIndex;
    setSelectedIndexState(newIndex);
    setLastSelectedIndex(newIndex);
    recalcOffset();
  };

  const [offset, setOffset] = useState(0);
  const viewportRef = useRef<HTMLDivElement | null>(null);
  let imgCount = 0;

  const recalcOffset = () => {
    const wrap = viewportRef.current;
    if (!wrap) return;

    const cards = wrap.querySelectorAll<HTMLDivElement>('.card');
    const selected = cards[selectedIndexRef.current];
    if (!selected) return;

    const viewport = wrap.offsetWidth;
    const lastCard = cards[cards.length - 1];
    const layout = lastCard.offsetLeft + lastCard.offsetWidth;

    const gap = layoutType === 'desktop' ? 308 : 346;
    imgCount = Math.floor(viewport / gap);

    const maxLeft = Math.max(layout - viewport, 0);
    const clamped = Math.min(selected.offsetLeft, maxLeft);
    setOffset(-clamped);
  };

  useLayoutEffect(() => {
    window.addEventListener('resize', recalcOffset);
    recalcOffset();
    return () => window.removeEventListener('resize', recalcOffset);
  }, []);

  const goPrev = () => setSelectedIndex((prev) => Math.max(0, prev - 1));
  const goNext = () => setSelectedIndex((prev) => Math.min(Math.min(cards.card.length - 1, cards.card.length - imgCount), prev + 1));
  const handleCardClick = (idx: number) => setSelectedIndex(idx);

  return (
    <>
      <ExtraContentLayout bgImg={extraContentBanner}>
        <ExtraContentSection>
          <StyledGridContainer>
            <StyledDisplay size="small" color="#fff">
              <Trans i18nKey={`ORBRO Blog`} />
            </StyledDisplay>

            <Spacing pixel="48" />

            <DivFlexRow>
              <BannerProductButton onClick={goPrev}>
                <ImgWH w="24" h="24" src={IconArrowLeftWhite} />
              </BannerProductButton>

              <SpacingR pixel="8" />

              <BannerProductButton onClick={goNext}>
                <ImgWH w="24" h="24" src={IconArrowRightWhite} />
              </BannerProductButton>
            </DivFlexRow>

            <SpacingDTM d={'48'} t="48" m="48" />

            <BannerProductCardViewport ref={viewportRef}>
              <HomeProductCardTrack $offset={offset}>
                {cards.card.map((product, index) => (
                  <DivFlexColumn key={product.title}>
                    <ExtraContentCard
                      className="card"
                      bgImg={product.bgImg[layoutType]}
                      onClick={() => handleCardClick(index)} // 데모용
                    />
                    <Spacing pixel="24" />
                    <HeadingH3white size="xxsmall">
                      <Trans i18nKey={`${dataPath}.card.${index}.title`} />
                    </HeadingH3white>
                    <Spacing pixel="4" />
                    <ParagraphColor size="medium" color={'#ffffff99'}>
                      <Trans i18nKey={`${dataPath}.card.${index}.desc`} />
                    </ParagraphColor>
                    <Spacing pixel="24" />

                    <ShowMoreButton href={i18n.language === 'ko' ? `${product.link}` : `/${i18n.language}${product.link}`} rel="noopener noreferrer">
                      <ShowLabel>
                        <LabelColor color="#fff" size="medium">
                          <Trans i18nKey={`home.showMore`} />
                        </LabelColor>
                        <ImgWHRotation w="20" h="20" rotate={true} src={IconArrowUpWhite} />
                      </ShowLabel>
                    </ShowMoreButton>
                  </DivFlexColumn>
                ))}
              </HomeProductCardTrack>
            </BannerProductCardViewport>
          </StyledGridContainer>
        </ExtraContentSection>
      </ExtraContentLayout>
    </>
  );
};

export default ExtraContentSolution;
